module.exports = __webpack_public_path__ + "static/img/15.6d55d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/15.png
// module id = Ax0G
// module chunks = 1